import React, { useState, useEffect } from "react";
import "./Component.css";
import{Data,Datas } from "./Datalist";


function ReImageText() {
   const [isLargeScreen, setIsLargeScreen] = useState(() =>
          window.matchMedia("(min-width: 1280px)").matches
        );
      
        // Hook to listen for window resize and update the screen size state
        useEffect(() => {
          const mediaQuery = window.matchMedia("(min-width: 1280px)");
          const handleChange = (e) => setIsLargeScreen(e.matches);
          mediaQuery.addEventListener("change", handleChange);
      
          // Clean up the event listener on unmount
          return () => {
            mediaQuery.removeEventListener("change", handleChange);
          };
        }, []);
  return (
    
    <>
      {isLargeScreen &&
        Data.map(({ image, content, flexReverse }, index) => (
          <div
            key={index}
            className={`parent-container upx-20 m-0 upy-10 d-flex ${
              flexReverse ? "flex-row-reverse" : ""
            }`}
          >
            {/* Image Section */}
            <div
              className="uw-130 uh-120 br-5 box-shadow"
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>

            <div className="m-0 p-0 uw-20 uh-120"></div>

            {/* Dynamic Text Section */}
            <div className="para m-0 p-0 uw-130 uh-120 d-flex br-5 flex-column text-start justify-content-center">
              {content}
            </div>
          </div>
        ))}

      {!isLargeScreen &&
       Datas.map(({ image, content }, index) => (
        <div
          key={index}
          className="parent-container upx-20 mt-5 box-shadow upy-10 d-flex flex-column align-items-center"
        >
          {/* Image Section */}
          <div
            className="w-100 uh-250 br-10 box-shadow"
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
    
          {/* Text Section */}
          <div className="para  p-3 w-100 d-flex br-5 flex-column text-start justify-content-center  ">
            {content}
          </div>
        </div>
          
        ))}
    </>
    
  );
}

export default ReImageText;
